import { DemoLead } from "@forwardflow/types/demo-conversation";

export const convertInterestTypeToCampaignType = (interestType: string): string => {
  const normalizedType = interestType?.toLowerCase().trim();

  switch (normalizedType) {
    case 'buyer':
      return 'demo-buyer';
    case 'seller':
      return 'demo-seller';
    case 'demo-buyer':
    case 'demo-seller':
      return normalizedType;
    default:
      return 'demo-seller';
  }
};

export const getStageDisplayName = (stageName: string | undefined) => {
  switch (stageName) {
    case 'ff-lead':
      return 'New Lead';
    case 'ff-appointment-set':
      return 'APT Set';
    case 'ff-do-not-contact':
      return 'DNC';
    case 'ff-hot-prospect':
      return 'Hot Prospect';
    case 'ff-cold-prospect':
      return 'Cold Prospect';
    case 'ff-reactivate':
      return 'Reactivated';
    case 'ff-appointment-missed':
      return 'APT Missed';
    case 'ff-long-term':
      return 'Long Term';
    default:
      return stageName || '';
  }
}

export const getCampaignTypeDisplayName = (campaignType: string | undefined) => {
  switch (campaignType) {
    case 'demo-buyer':
      return 'Buyer';
    case 'demo-seller':
      return 'Seller';
    default:
      return campaignType || '';
  }
}

export const getDefaultValues = () => ({
  timelineSummary: 'This lead has not started any conversation yet',
  questions: 'No questions have been asked by this lead yet',
  appointmentInfo: {
    date: undefined,
    status: undefined,
    platform: undefined
  }
})

export const transformApiResponseToLead = (apiLead: any): DemoLead => {
  const propertyInfo = apiLead.data.eventInfo?.property
    ? `${apiLead.data.eventInfo.property.street || ''}, ${apiLead.data.eventInfo.property.city || ''} ${apiLead.data.eventInfo.property.code || ''}`.trim()
    : apiLead.data.propertyInfo || null;

  return {
    leadId: apiLead.leadId,
    userInfo: {
      firstName: apiLead.data.userInfo.firstName,
      lastName: apiLead.data.userInfo.lastName,
      email: apiLead.data.userInfo.email,
      phone: apiLead.data.userInfo.phone,
      id: apiLead.data.userInfo.id,
      avatar: apiLead.data.userInfo.avatar || null
    },
    leadInterestType: convertInterestTypeToCampaignType(apiLead.data.leadInterestType),
    agentInfo: apiLead.data.agentInfo ? {
      id: apiLead.data.agentInfo.id,
      name: apiLead.data.agentInfo.name
    } : undefined,
    sourceInfo: {
      id: apiLead.data.sourceInfo.id,
      name: apiLead.data.sourceInfo.name
    },
    stageInfo: {
      id: apiLead.data.stageInfo.id,
      name: apiLead.data.stageInfo.name
    },
    appointmentInfo: {
      date: apiLead.data.appointmentInfo.date || null,
      status: apiLead.data.appointmentInfo.status || null,
      platform: apiLead.data.appointmentInfo.platform || null
    },
    conversationInfo: apiLead.data.conversationInfo ? {
      callsAnswered: apiLead.data.conversationInfo.callsAnswered,
      callsAttempted: apiLead.data.conversationInfo.callsAttempted,
      messagesReplied: apiLead.data.conversationInfo.messagesReplied,
      messagesSent: apiLead.data.conversationInfo.messagesSent
    } : undefined,
    assistantInfo: {
      id: apiLead.data.assistantInfo?.id,
      name: apiLead.data.assistantInfo?.name,
    },
    propertyInfo: propertyInfo,
    tags: apiLead.data.tags,
    timelineSummary: apiLead.data.timelineSummary,
    questions: apiLead.data.questions,
    specificFeatures: apiLead.data.specificFeatures,
    assignedPhoneNumber: apiLead.data.assignedPhoneNumber,
    lastConversation: apiLead.data.lastConversation,
    preDefinedTimelineHistory: apiLead.data?.preDefinedTimelineHistory || [],
    eventInfo: apiLead.data.eventInfo ? {
      property: apiLead.data.eventInfo.property
    } : undefined
  }
}